import { createActions, using } from "redux-box";

export default createActions({
  getCategoryData: using(),
  requestCreateCategory: using("category"),
});
